<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Edit Component" | translate | async }}
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body div-flex-col gap-30">

    <div>
      <span class="text-block__label">
        {{ "Current Component: " | translate | async }}
      </span>
      <span class="text-block__important" style="font-weight: bold;">
        {{ _currentComponent }}
      </span>
    </div>
    <div class="div-flex-col gap-10"> 
      <span class="text-block__label">
        {{ "List of available components" | translate | async }}
      </span>
      <mat-form-field >
        <mat-select name="SysReplaceActions" placeholder="{{ 'Select Replacement' | translate | async }}" [(ngModel)]="_newComponentId">
          <mat-option *ngFor="let action of _componentReplaceOptions" [value]="action.Id">{{ action.Name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="div-flex-row gap-10">
      <mat-form-field>
        <mat-select placeholder="{{ 'Select Brand' | translate | async }}" [(ngModel)]="_make">
          <mat-option *ngFor="let make of _Makes" [value]="make.Id">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput type="number" placeholder="{{'Budget Life'  | translate | async}}" [(ngModel)]="_budgetLife" (ngModelChange)="onChange()">
      </mat-form-field>
    </div>
    <div *ngIf="_componentType == _componentTypes.Shoe">
      <div class="ttmodal__header">
        <span class="ttmodal__title">
          {{ "Shoe Infomation" | translate | async }}
        </span>
      </div>
      <div class="ttmodal__body">
        <div>
          <mat-form-field>
            <mat-select name="size" placeholder="{{ 'Shoe Size' | translate | async }}" [(ngModel)]="_shoeSize">
              <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-select name="grouser" placeholder="{{ 'Grouser' | translate | async }}" [(ngModel)]="_grouserId">
              <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-select name="cleanerholes" placeholder="{{ 'Cleaner Holes' | translate | async }}" [(ngModel)]="_cleanerHolesId">
              <mat-option *ngFor="let hole of _availableCleanerholes" [value]="hole.Id">{{hole.Title}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="_componentType == _componentTypes.Link">
      <div class="ttmodal__header">
        <span class="ttmodal__title">
          {{ "Link Infomation" | translate | async }}
        </span>
      </div>
      <div class="ttmodal__body">
        <div>
          <mat-form-field>
            <mat-select name="size" placeholder="{{'Master Link'  | translate | async}}" [(ngModel)]="_masterLink">
              <mat-option [value]=0>Unknown</mat-option>
              <mat-option [value]=1>M</mat-option>
              <mat-option [value]=2>S</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <input matInput placeholder="{{'Job #'  | translate | async}}" [(ngModel)]="_jobNumber">
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="_componentType == _componentTypes.Bushing">
      <div class="ttmodal__header">
        <span class="ttmodal__title">
          {{ "Bush Infomation" | translate | async }}
        </span>
      </div>
      <div class="ttmodal__body" style="display: flex; gap: 16px; align-items: center;">
        <div>
          <mat-form-field style="flex: 1;">
            <input matInput type="number" placeholder="{{'Bushed Turned Budget %'  | translate | async}}" [(ngModel)]="_bushTurnedBudgetPer" (ngModelChange)="onChange()">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field style="flex: 1;">
            <input matInput type="number" placeholder="{{'Bushed Turn Hours'  | translate | async}}" [(ngModel)]="_bushTurnedHours" readonly>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="_componentType == _componentTypes.Idler">
      <div class="ttmodal__header">
        <span class="ttmodal__title">
          {{ "Idler Infomation" | translate | async }}
        </span>
      </div>
      <div class="ttmodal__body">
        <div>
          <mat-form-field>
            <input matInput placeholder="{{'Asset #'  | translate | async}}" [(ngModel)]="_assetNumber">
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="ttmodal__footer footer">
      <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
      <button mat-raised-button color="warn" (click)="onSave()" [class.loading]="_saving"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Save/Update' | translate | async }} </span></button>
    </div>
  </div>
</div>